import { useAutoExchange } from '@/features/onboarding/hooks/use-auto-exchange';

interface UseCompleteStepOptions {
  isAuthenticated: boolean;
  isExchanging: boolean;
  exchangeError: string | null;
  onExchange: () => Promise<boolean>;
}

/**
 * Hook for CompleteStep behavior
 * Handles auto-triggering JWT exchange on mount
 */
export function useCompleteStep({
  isAuthenticated,
  isExchanging,
  exchangeError,
  onExchange,
}: UseCompleteStepOptions): void {
  useAutoExchange({
    isAuthenticated,
    isExchanging,
    exchangeError,
    onExchange,
  });
}
